/**
 * Global site popup (side modal).
 * Shows after delay, closes on X or backdrop; once per session.
 */
( function () {
  const STORAGE_KEY = 'b3rg_global_popup_seen';
  const SHOW_DELAY_MS = 2000;

  let seenInMemory = false;
  const storageOk = detectStorage();

  function detectStorage() {
    try {
      sessionStorage.setItem( STORAGE_KEY, sessionStorage.getItem( STORAGE_KEY ) || '' );
      return true;
    } catch ( e ) {
      return false;
    }
  }

  function getSeen() {
    if ( ! storageOk ) return seenInMemory;
    try {
      return !! sessionStorage.getItem( STORAGE_KEY );
    } catch ( e ) {
      return seenInMemory;
    }
  }

  function setSeen() {
    if ( ! storageOk ) {
      seenInMemory = true;
      return;
    }
    try {
      sessionStorage.setItem( STORAGE_KEY, '1' );
    } catch ( e ) {
      seenInMemory = true;
    }
  }

  function showPopup( popup, isDialog ) {
    popup.classList.add( 'is-visible' );
    const useNative = isDialog && typeof popup.showModal === 'function';
    useNative ? popup.showModal() : popup.setAttribute( 'aria-hidden', 'false' );
  }

  function hidePopup( popup, isDialog ) {
    popup.classList.remove( 'is-visible' );
    const useNative = isDialog && typeof popup.close === 'function';
    useNative ? popup.close() : popup.setAttribute( 'aria-hidden', 'true' );
    setSeen();
  }

  function bindClose( popup, isDialog ) {
    const onClose = () => hidePopup( popup, isDialog );
    popup.querySelectorAll( '[data-b3rg-popup-close]' ).forEach( ( el ) => el.addEventListener( 'click', onClose ) );
    if ( isDialog ) popup.addEventListener( 'cancel', onClose );
  }

  function setupPopup() {
    const popup = document.getElementById( 'b3rg-global-popup' );
    if ( ! popup ) return;

    const isDialog = popup.localName === 'dialog';
    bindClose( popup, isDialog );
    if ( getSeen() ) return;

    setTimeout( () => showPopup( popup, isDialog ), SHOW_DELAY_MS );
  }

  function runWhenReady( fn ) {
    if ( document.readyState === 'loading' ) {
      document.addEventListener( 'DOMContentLoaded', fn );
    } else {
      fn();
    }
  }

  runWhenReady( setupPopup );
} )();
